import { React, models, kea, history, resources, selectores, componentToRx, Route, match, withRouter, createSelectorRx } from "app/main/std";
import { OrigenUsuarioApiForm } from "./form";
import { observeResource } from "kea-resource";
type Entity = models.OrigenUsuarioApi;
const resource = resources.origenesUsuarioApi;

interface Props {
    match: match<{ id: string, idUsuarioApi: string }>
}
interface State {
    value: Promise<Entity> | Entity;
}
class OrigenUsuarioApiEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: this.getValue() };
    }

    get id(): number | "new" {
        const id = this.props.match.params.id;
        return id == "new" ? id : Number.parseInt(id);
    }

    idUsuarioApi = (props: Props) => Number.parseInt(this.props.match.params.idUsuarioApi);
    usuarioApi = createSelectorRx(this.idUsuarioApi, id =>  resources.UsuarioApi.get(id));
    idCliente = createSelectorRx(this.usuarioApi, usuario => usuario.IdCliente);

    async getValue() {
        if (this.id == "new") {
            return {    
                IdUsuarioApi: this.idUsuarioApi(this.props)
            } as Entity;
        } else {
            return await resource.get(this.id);
        }
    }

    onChange = (value: Entity) => this.setState({ value });
    onGuardar = async () => {
        const id = this.id;
        const func = id == "new" ? resource.add : resource.update;
        const value = await this.state.value;
        await func(value);
        history.go("/catalogos/UsuarioApi/" + this.idUsuarioApi(this.props));
    }

    render() {
        const props = this.props;
        const params = props.match!.params.id;

        return (
            <OrigenUsuarioApiForm
                value={this.state.value}
                onChange={this.onChange}
                onGuardar={this.onGuardar}
                idCliente={this.idCliente(this.props)}
                nuevo={this.id == "new"}
            />
        );
    }
}

export const OrigenUsuarioApiEdit = withRouter(OrigenUsuarioApiEditComp);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarioApi/edit/origen/edit/index.tsx